import React from 'react';
import Link from 'gatsby-link';
import styled, { keyframes } from 'styled-components';
import { PageWrapper, mediaQueries, spacing, fonts, fontSizes, colors } from '../components/Styling';

const activeClassName = 'nav-item-active';

const fadeback = keyframes`
  from{
    opacity: 0;
    transform: translate(0, 50%);
  }
  to{
    opacity: 1;
    transform: translate(0, 0%);
  }
`;

const NavWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-family: ${fonts.serif};
  justify-content: space-between;
  padding: 0;
  position: relative;
`;

const Nav = styled.nav`
  animation: none;
  display: flex;
  flex-direction: column;
  margin-top: ${spacing[4]};
  position: absolute;
  top: 0;
  transform: translateX(-100%);

  ${mediaQueries.medium`
    animation: .3s ease ${fadeback} !important;
    flex-direction: row;
    margin: initial;
    opacity: initial;
    position: initial;
    transform: none;
    transition: initial;
    z-index: initial;
  `};
`;

const NavItem = styled(Link).attrs({ activeClassName })`
  font-weight: 100;
  letter-spacing: 0.05em;
  margin-bottom: ${spacing[5]};
  margin-right: 3rem;
  text-decoration: none;
  text-align: right;
  white-space: nowrap;

  ${mediaQueries.medium`
    margin-right: calc(5em + 1.5vw);
    margin-bottom: initial;
    text-align: initial;
  `};

  &.${activeClassName} {
    span:first-child:after {
      transform: scaleX(1);
    }
  }
`;

const Logo = NavItem.extend`
  font-family: ${fonts.sans};
  font-weight: 600;
  text-align: right;
  margin: 0 !important;
`;

const StyledHamburger = styled.a`
  cursor: pointer;
  display: inline-block;
  height: 30px;
  left: 0;
  top: 0;
  position: relative;
  width: 30px;

  ${mediaQueries.medium`
    display: none;
  `};

  & span,
  & span:before,
  & span:after {
    background-color: ${colors.black};
    display: block;
    height: 2px;
    position: absolute;
    width: 30px;
    transition-duration: 0.2s;
  }
  & span {
    background-color: ${props => props.isActive ? 'rgba(0, 0, 0, 0)' : 'black'};
    top: 50%;
    transition-delay: ${props => props.isActive ? '0' : '.1s'};
    transform: translateY(-50%);
  }
  & span:before,
  & span:after {
    content: '';
    transition-property: transform;
    transition-delay: ${props => props.isActive ? '0.1s' : '0s'};
  }

  & span:before {
    top: -9px;
    transform: ${props => props.isActive ? 'translateY(9px) rotate(45deg)' : 'initial'};
  }
  & span:after {
    top: 9px;
    transform: ${props => props.isActive ? 'translateY(-9px) rotate(-45deg)' : 'initial'};
  }
`;

class Hamburger extends React.Component {
  constructor(props) {
    super(props);
  }

  click = () => {
    this.props.toggleNav();
  };

  render() {
    return (
      <StyledHamburger isActive={this.props.isActive} className={this.props.className} onClick={this.click}>
        {this.props.children}
      </StyledHamburger>
    );
  }
}

const NavLabel = styled.span`
  font-size: ${fontSizes[3]};
  color: ${colors.black};
  position: relative;

  &:after {
    border-bottom: 2px solid ${colors.black};
    bottom: -0.05rem;
    content: '';
    display: ${props => props.logo ? 'none' : 'initial'};
    height: 100%;
    left: 0;
    position: absolute;
    transform-origin: center;
    transform: scaleX(0);
    transition: transform 0.2s;
    width: 100%;
  }

  &:hover:after {
    transform: scaleX(1);
  }
`;

export class NavBar extends React.Component {
  constructor(props) {
    super(props);
  }

  toggleNav = value => {
    this.props.toggleNav(value);
  };

  render() {
    return (
      <NavWrapper>
        <Hamburger isActive={this.props.isActive} toggleNav={this.toggleNav}>
          <span />
        </Hamburger>
        <Nav isActive={this.props.isActive} onClick={() => this.toggleNav(false)}>
          <NavItem to="/" exact>
            <NavLabel>Work</NavLabel>
          </NavItem>
          <NavItem to="/about">
            <NavLabel>About</NavLabel>
          </NavItem>
          <NavItem to="/contact">
            <NavLabel>Contact</NavLabel>
          </NavItem>
        </Nav>
        <Logo to="/" exact>
          <NavLabel logo>Grimm Sound</NavLabel>
        </Logo>
      </NavWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js